import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";
import {useContractDescriptionExists} from "../../../services/contracts";

const AddContractDialogValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;

  const extraKeys = [record.contractName, record.contractedPartyUuid || "null"];
  const contractDescriptionExists = useContractDescriptionExists({extraKeys});

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }

  if (!error && !record.contractType) {
    error = true;
    errorMessage = "'Contract Type' is required";
    id="contractType";
  }
  if (!error && !record.contractName) {
    error = true;
    errorMessage = "Unique 'Contract Description' is required";
    id="contractName";
  }
  if (!error && record.contractName && record.contractName !== "" && contractDescriptionExists && contractDescriptionExists.data && contractDescriptionExists.data.status) {
      error = true;
      errorMessage = "'Contract Description' already exists, choose a unique description for the contract";
      id="contractName";
  }
  if (!error && !record.contractReference) {
    error = true;
    errorMessage = "'Contract Reference' is required";
    id="contractReference";
  }
  // if (!error && !record.contractRevision) {
  //   error = true;
  //   errorMessage = "'Contract Revision' is required";
  // }
  const startDate = moment(record.contractStartDate);
  if (!error && !startDate.isValid()) {
    error = true;
    errorMessage = "'Contract Start Date' does not contain a valid date";
    id="contractStartDate";
  }
  const endDate = moment(record.contractEndDate);
  if (!error && !endDate.isValid()) {
    error = true;
    errorMessage = "'Contract End Date' does not contain a valid date";
    id="contractEndDate";
  }
  if (!error && record.contractStartDate && record.contractEndDate && endDate.isBefore(startDate)) {
    error = true;
    errorMessage = "Contract 'End Date' cannot be prior to 'Start Date";
    id="contractEndDate";
  }
  if (!error && !record.contractedPartyUuid) {
    error = true;
    errorMessage = "'Contracted Party' is required";
    id="contractedPartyUuid";
  }
  if (!error && (record.active !== true && record.active !== false)) {
    error = true;
    errorMessage = "'Active' should be either true or false";
    id="active";
  }
  if (!error && (record.fuelAnnexRequired !== true && !record.revenueAmount)) {
    error = true;
    errorMessage = "'Revenue Amount'  is required";
    id="revenueAmount";
  }
  if (!error && (record.fuelAnnexRequired !== true && !record.currencyCode)) {
    error = true;
    errorMessage = "'Currency'  is required";
    id="currencyCode";
  }
  if (!error && (record.fuelAnnexRequired)) {
    if (!record.routes || record.routes.length === 0) {
      error = true;
      errorMessage = "There are no fuel annex routes associated with this contract";
      id="routes";
    }
  }
  
  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );
}

export default AddContractDialogValidator;
